import { useEffect } from "react";
import { getAssetUrl } from "../utils/assetUrl";

const BODY_BG_VIDEO_URL = getAssetUrl(
  `${process.env.PUBLIC_URL ?? ""}/assets/bg-pc.mp4`
);
const BODY_BG_MOBILE_VIDEO_URL = getAssetUrl(
  `${process.env.PUBLIC_URL ?? ""}/assets/bg-mb.mp4`
);

function applyVideoBodyBg() {
  document.body.style.backgroundColor = "#001446";
  document.body.style.backgroundImage = "none";
  document.body.style.backgroundSize = "cover";
  document.body.style.backgroundPosition = "center";
  document.body.style.backgroundRepeat = "no-repeat";
  document.body.style.backgroundAttachment = "scroll";
}

/** Đồng bộ nền body: desktop dùng bg-pc, mobile dùng bg-mb trong public/assets. */
export default function BodyBackgroundSync() {
  useEffect(() => {
    applyVideoBodyBg();
  }, []);

  return (
    <>
      <video
        className="app-body-video-bg app-body-video-bg--desktop"
        src={BODY_BG_VIDEO_URL}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />
      <video
        className="app-body-video-bg app-body-video-bg--mobile"
        src={BODY_BG_MOBILE_VIDEO_URL}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />
    </>
  );
}
